module.exports = __webpack_public_path__ + "img/fish6.6f196d2a.png";